
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 2.5a12.013 12.013 0 00-12 12 1 1 0 102 0 10.023 10.023 0 114.379 8.26l1.805-2.26a.5.5 0 00-.349-.809l-6.672-.568a.5.5 0 00-.519.65l2.042 6.377a.5.5 0 00.867.159l1.578-1.98A12 12 0 1014 2.5z","fill":"#565D6D"}}),_c('path',{attrs:{"d":"M14 6.5a1 1 0 00-1 1v7a1 1 0 001 1h7a1 1 0 000-2h-6v-6a1 1 0 00-1-1z","fill":"#565D6D"}})])
          )
        }
      }
    